<template>
  <div>
    <vx-card>
      <button @click="$router.push('/login')">
        <i class="fa fa-arrow-left mr-2 mb-4" />Login
      </button>
      <router-view></router-view>
    </vx-card>
    <footer
      class="flex flex-wrap"
      style="position: fixed;
      bottom: 0px;
    justify-content: space-around;
    align-items: center;
    width: 100%;
   background-color: rgb(3 38 95);
    height: 45px;
    box-shadow: 5px 10px 20px 7px;"
    >
      <router-link to="/legal/about-us" class="text-white">
        <p>
          <i class="fa fa-briefcase" />
          About Us
        </p>
      </router-link>
      <router-link to="/legal/privacy-policy" class="text-white">
        <p>
          <i class="fa fa-shield" />
          Privacy Policy
        </p>
      </router-link>
      <router-link to="/legal/distance-sales-agreement" class="text-white">
        <p>
          <i class="fa fa-shopping-cart" />
          Distance Sales Agreement
        </p>
      </router-link>
      <router-link to="/legal/cookie-policy" class="text-white">
        <p>
          <i class="fa fa-book" />
          Cookie Policy
        </p>
      </router-link>
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>